export const getNussbergData = () => ({
  name: "Nussberg",
  region: "Wien",
  country: "Autriche",
  description: "Nussberg est une colline viticole urbaine de Wien, spécialisée dans les vins blancs de qualité. Cette région bénéficie d'un climat continental avec des influences urbaines, créant des conditions particulières pour la viticulture.",
  type: "subregion",
  area: "200 ha",
  production: "0.01 million hectolitres",
  climate: "Climat continental avec influences urbaines, étés chauds et hivers froids",
  soil: "Sols calcaires, argileux, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec influences urbaines, étés chauds et hivers froids",
    soil: "Sols calcaires, argileux, excellente diversité géologique",
    viticulture: "Viticulture urbaine, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une acidité vive",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Nussberg remonte à l'époque romaine. La colline a une tradition viticole unique avec des vignobles urbains. Aujourd'hui, Nussberg est reconnue pour ses vins urbains de qualité et son approche innovante.",
  foodPairing: "Cuisine viennoise traditionnelle, plats urbains, fromages affinés, cuisine internationale",
  grapeVarieties: [
    {
      name: "Grüner Veltliner",
      percentage: "50%",
      description: "Cépage emblématique d'Autriche, produisant des vins blancs secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Riesling",
      percentage: "25%",
      description: "Cépage blanc produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Chardonnay",
      percentage: "15%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "5%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Nussberg", x: 16.4, y: 48.2, color: "#4B164C", size: 2 }
  ]
}); 